import { adminLogin, adminLogout, adminCurrent } from '@/api/admin'
import { getToken, setToken, removeToken, getUserInfo, setUserInfo, removeUserInfo, setArchiveApp } from '@/utils/auth'

// 用户模块：管理端登录态（token + 用户信息）
const state = {
    token: getToken() || '',
    userInfo: getUserInfo()
}

const mutations = {
    SET_TOKEN (state, token) {
        state.token = token || ''
    },
    SET_USER_INFO (state, userInfo) {
        state.userInfo = userInfo || null
    }
}

const actions = {
    // 登录：后端返回 { adminToken, expiresIn, user }，本地持久化 token 与用户信息
    async login ({ commit }, form) {
        const res = await adminLogin(form)
        const data = res.data || {}
        if (!data.adminToken) {
            throw new Error('登录返回数据异常')
        }
        setToken(data.adminToken)
        setUserInfo(data.user || {})
        commit('SET_TOKEN', data.adminToken)
        commit('SET_USER_INFO', data.user || {})
        return data
    },

    // 登出：吊销后端令牌并清理本地登录态
    async logout ({ commit, state }) {
        try {
            if (state.token) {
                await adminLogout()
            }
        } catch (error) {
            // 后端登出失败不阻塞本地清理
        }
        removeToken()
        removeUserInfo()
        setArchiveApp(null)
        commit('SET_TOKEN', '')
        commit('SET_USER_INFO', null)
    },

    // 刷新页面后从本地缓存恢复用户信息
    restoreUserInfo ({ commit }) {
        commit('SET_USER_INFO', getUserInfo())
    },

    // 拉取当前用户信息（用于校验 token 是否仍有效）
    async refreshUserInfo ({ commit }) {
        const res = await adminCurrent()
        const user = res.data || null
        setUserInfo(user)
        commit('SET_USER_INFO', user)
        return user
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
